import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ExperimentService } from 'src/app/_services';

export const snsLandingVariantResolver: ResolveFn<string> = () => {
  const experimentService = inject(ExperimentService);
  // Pass your specific test key here. You may need to inject your AuthService if you need the userId.
  return experimentService.getVariant('sns_landing_v2', null); 
};